<template>
  <div class="mycomment">
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="img.loading" />
    </div>
    <div class="comment" v-for="item in list" :key="'list_'+item.id">
      <p class="f-15 f-w">我评论：</p>
      <div class="f-12 ellipsis-2">
        {{item.content}}
        <p class="f-12 c-gray">
          <span class="f-l">{{item.created_at}}</span>
          <!-- <span class="f-r">删除</span> -->
        </p>
      </div>
    </div>
  </van-list>
</div>
</template>
<script>
  import common from '../../../api/common';
  import list from '../../../api/member/mymessage';
  import { mapState } from 'vuex';
  import { List, Row, Col, Cell, CellGroup,SwipeCell} from 'vant';
  export default {
    data () {
      return {
        list:[],
        params:{
          page:1
        },
        loading: false,
        finished: false,
        img:{
          loading: require('../../../assets/img/loading_lexus.gif'),
          approve: require('../../../assets/img/lexus/member/approceing.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      var params={
        event_code: '我的评论',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/MyComment.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      onLoad(){
        setTimeout(() => {
          list.getCommentsList(this.params).then(res => {
            this.list.push.apply(this.list, res.data.data)
            this.params.page += 1
            this.loading = false
            if(res.data.data.length == 0) {
              this.finished = true
            }
          })
        }, 500);
      }
    },
    components: {
      [Row.name]: Row,
      [Col.name]: Col,
      [List.name]: List,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [SwipeCell.name]:SwipeCell
    }
  }
</script>

<style lang="scss">
.mycomment{
  .comment{
    padding: 0 15px;
    border-bottom:1px solid #eaeaea;
  }
}
</style>
